<template>
  <div :class="[ messageShow ? 'messageBackStyleP':'messageBackStyle','message']">
    <div class="messageInfo" @click="messageClose( true )">
      <div></div>
      <span class="messageInfoText">消息</span>
    </div>

    <div v-if="messageShow" class="messageCon">

      <div :class="[isActive?'active':'','messageCenterBox']">

        <div v-if="!isDetailNotice" class="list">
          <ul class="paging">
            <li class="elementList borderRadius">
              <div class="item_p pad12">
                <img src="../../../assets/img/messageCenter.png" alt="">
                <div class="elementInfo">
                  <div class="top">
                    <div class="title">
                      <p class="typeName">消息中心</p>
                    </div>
                  </div>
                </div>
              </div>

            </li>
            <div class="overflowAuto">
              <li v-for="item in msgList" :key="item.id" :class="[activeId == item.id?'activeColor':'','elementList']" @click="goLookDetail( item )">
                <div class="item_p">
                  <span v-if="item.is_read==2" class="red" />
                  <div class="elementInfo">
                    <div class="top">
                      <div class="title">
                        <p class="typeName">{{ item.title }}</p>
                        <p class="date">{{ item.created_at }}</p>
                      </div>
                    </div>
                  </div>
                </div>

              </li>

            </div>
          </ul>
        </div>
        <div class="messageDetail">

          <h3>{{ detailInfo.title }}</h3>

          <div class="detailContent">
            <p>{{ detailInfo.content }}</p>
          </div>

        </div>
        <img
          v-if="!isActive"
          class="messageClose"
          src="../../../assets/img/wrong.png"
          alt=""
          @click="messageClose( false )"
        >
      </div>
    </div>
  </div>
</template>

<script>

import { getNoticeList, readNotice }  from '@/http/index'
export default {
  name: "Message",
  props: ['sysMessageShow'],
  data() {
    return {
      createSocketIO: null,
      createSocketEmitter: null,
      tab: 1, // 1.系统消息、2.通知消息、3.积分消息
      msgList: [],
      unreadCount: 0,
      isMessageAllRead: false,
      isNoticeAllRead: false,
      isDetail: false,
      detailInfo: {},
      messageShow: false,
      isDetailNotice: false,
      isMessageDetail: true,
      isActive: false,
      activeId: ''
    };
  },
  computed: {},
  watch: {
    'messageShow': {
      handler(newSrc, oldSrc) {
        if (newSrc == true) {
          this.getList()
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
  },
  methods: {
    async getList() {
      const res = await getNoticeList({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        page: 1,
        size: 10000
      })
      this.msgList = res.data.data;
    },
    closeNotice() {
      this.messageShow = false;
      this.isDetailNotice = false;
      this.isActive = false;
    },
    messageCloseDetail() {
      if (this.isDetailNotice) {
        this.closeNotice();
      } else {
        this.isDetail = false;
      }
    },
    goLookDetail(item) {
      this.activeId = item.id;
      this.isDetail = true;
      this.detailInfo = item;
      this.goNoticeRead(item.id)
    },
    async goNoticeRead(id) {
      const res = await readNotice({
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        id: id
      })
      this.getList()
    },
    messageClose(val) {
      this.messageShow = val;
      this.tab = 1;
      if (this.messageShow) {
        this.getList();
      }
    }
  }

}

</script>

  <style lang="scss" scoped>
  :root {
    --scale: 1,
  }

  $scale: var(--scale, 1);
  .message {
    .messageInfo {
      width: calc(#{$scale} * 95px);
      height: calc(#{$scale} * 55px);
      border-radius: calc(#{$scale} * 10px);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgba(0,0,0,0.5);

      &:hover {
        background-color: rgba(0,0,0,0.8);
        div {
          background-image: url("../../../assets/img/new-msg-hover.png");
        }
        .messageInfoText{
          color: #F5BC41;
        }
      }

      div {
        width: calc(#{$scale} * 30px);
        height: calc(#{$scale} * 30px);
        background: url("../../../assets/img/new-msg.png");
        background-size: calc(#{$scale} * 30px) calc(#{$scale} * 30px);
        margin-right: 6px;
        .count {
          height: calc(#{$scale} * 18px);
          line-height: calc(#{$scale} * 18px);
          min-width: calc(#{$scale} * 18px);
          position: absolute;
          top: calc(#{$scale} * 16px);
          right: calc(#{$scale} * 11px);
          background-color: #F72727;
          border-radius: calc(#{$scale} * 12px);
          font-size: calc(#{$scale} * 10px);
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          text-align: center;
        }
      }
      .messageInfoText{
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: calc(#{$scale} * 15px);
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
      }

    }

    .messageCon {
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(14, 48, 58, 0.8) 0%, rgba(7, 29, 36, 0.8) 100%);
      backdrop-filter: blur(8px);
      display: flex;
      flex-direction: row;
      // align-items: center;
      padding-top: 7%;
      justify-content: center;
      position: relative;

      .messageClose {
        height: calc(#{$scale} * 32px);
        width: calc(#{$scale} * 32px);
        position: absolute;
        top: calc(#{$scale} * 15px);
        right: calc(#{$scale} * 15px);
        cursor: pointer;
      }

      .examBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 500px;
        height: 250px;
        border-radius: 10px;
        background: rgba(0, 24, 28, 0.6);

        h1 {
          margin-top: 34px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #FFFFFF;
          line-height: 32px;
          text-align: center;
          font-style: normal;
        }

        .examContent {
          margin-top: 14px;
          margin-bottom: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 32px;
          text-align: center;
          font-style: normal;
        }

        .examBtn {
          width: 120px;
          height: 48px;
          border-radius: 24px;
          background: #00AE9F;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 48px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
        }
      }
      .messageCenterBox {
        position: relative;
        background-color: #FFFFFF;
        width: calc(#{$scale} * 1000px);
        height: calc(#{$scale} * 716px);
        border-radius: calc(#{$scale} * 16px);
        display: flex;
        .header {
          height: calc(#{$scale} * 24px);
          width: 100%;
          display: flex;
          justify-content: space-between;

          .headerLeft {
            width: calc(#{$scale} * 110px);
            height: calc(#{$scale} * 24px);
            font-size: calc(#{$scale} * 24px);
            margin: 0;
            border-left: calc(#{$scale} * 6px) solid #028B73;
            padding-left: calc(#{$scale} * 8px);
          }

          .headerRight {
            width: calc(#{$scale} * 80px);
            height: calc(#{$scale} * 28px);
            font-size: calc(#{$scale} * 20px);
            color: #2DBBAB;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-right: calc(#{$scale} * 30px);
            line-height: calc(#{$scale} * 28px);
            cursor: pointer;
          }
        }

        .list {
          height: calc(#{$scale} * 716px);
          width: calc(#{$scale} * 240px);
          //margin-top: calc(#{$scale} * 14px);
          background-color: #F2F3F3;
          .paging {
            height: calc(#{$scale} * 716px);
            width: calc(#{$scale} * 240px);
            //overflow: auto;

            border-radius: calc(#{$scale} * 16px) 0 0 calc(#{$scale} * 16px);
            .overflowAuto{
              height: calc(100% - calc(#{$scale} * 65px));
              overflow: auto;
              border-radius: 0 0 0 calc(#{$scale} * 16px);
            }
            .borderRadius{
              border-radius: calc(#{$scale} * 16px) 0 0 0;
            }
            .elementList {
              padding: 0 calc(#{$scale} * 10px);
              background: #F8F9FB;
              width: 100%;
              //border-radius: calc(#{$scale} * 8px);
              //margin: calc(#{$scale} * 10px) 0;
              display: flex;
              //justify-content: space-between;
              align-items: center;
              position: relative;
              cursor: pointer;
              .pad12 {
                padding: calc(#{$scale} * 12px)!important;
              }
              //&:hover {
              //    background: #f0f0f1;
              //}
              .item_p{
                width: calc(#{$scale} * 190px);
                padding: calc(#{$scale} * 20px) calc(#{$scale} * 10px) calc(#{$scale} * 15px) calc(#{$scale} * 10px);
                display: flex;
                align-items: center;
              }
              .red {
                width: calc(#{$scale} * 8px);
                height: calc(#{$scale} * 8px);
                border-radius: 50%;
                background-color: #E42F2F;
                position: absolute;
                top: calc(#{$scale} * 15px);
                left: calc(#{$scale} * 20px);
              }

              .element {
                // margin-left: calc(#{$scale} * 9px);
                position: absolute;
                top: calc(#{$scale} * 12px);
                right: calc(#{$scale} * 12px);
                display: inline-block;
                background-image: url("../../../assets/img/close-sy.png");
                background-size: cover;
                width: calc(#{$scale} * 16px);
                height: calc(#{$scale} * 16px);
              }

              img {
                width: calc(#{$scale} * 40px);
                height: calc(#{$scale} * 40px);
                //margin-left: calc(#{$scale} * 20px);
              }

              .elementInfo {
                //width: calc(#{$scale} * 800px);
                // height: calc(#{$scale} * 500px);
                margin-left:calc(#{$scale} * 10px);
                width: calc(#{$scale} * 220px);
                width: 100%;
                .top {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  .title {
                    width: 100%;
                    font-family: PingFangSC-Regular, PingFang SC;

                    .typeName {
                        width: 100%;
                      font-size: calc(#{$scale} * 16px);
                      color: #121212;
                      font-weight: 600;
                      margin-bottom: calc(#{$scale} * 2px);
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }

                    .date {
                      font-size: calc(#{$scale} * 14px);
                      color: #999999;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    }
                  }
                }

                .bottom {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  .center {
                    width: calc(#{$scale} * 620px);
                    font-size: calc(#{$scale} * 16px);
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: calc(#{$scale} * 22px);
                    // text-align: center;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }

                  .time {
                    font-size: calc(#{$scale} * 16px);
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: calc(#{$scale} * 22px);
                    display: flex;
                    align-items: center;
                  }
                }

              }

            }
            .activeColor{
              background: #E5E9E9;
            }
          }
        }
        .messageDetail {
          width: calc(#{$scale} * 740px);
          padding: calc(#{$scale} * 43px) calc(#{$scale} * 50px);
          h3 {
            text-align: center;
            //height: calc(#{$scale} * 33px);
            font-size: calc(#{$scale} * 18px);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #121212;
            line-height: calc(#{$scale} * 33px);
            text-align: left;
          }

          .detailTitle {
            margin-top: calc(#{$scale} * 19px);
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            height: calc(#{$scale} * 33px);

            span {
              height: calc(#{$scale} * 28px);
              font-size: calc(#{$scale} * 20px);
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: calc(#{$scale} * 28px);
            }
          }

          .detailContent {
            height: calc(#{$scale} * 580px);
            overflow-y: auto;
            overflow-x: hidden;

            p {
              margin-top: calc(#{$scale} * 8px);
              //width: calc(#{$scale} * 900px);
              font-size: calc(#{$scale} * 15px);
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: calc(#{$scale} * 26px);

            }
          }

          .detailBut {
            width: calc(#{$scale} * 200px);
            height: calc(#{$scale} * 48px);
            line-height: calc(#{$scale} * 48px);
            background: #028B73 linear-gradient(180deg, #05BFAB 0%, #028B73 100%);
            border-radius: calc(#{$scale} * 8px);
            font-size: calc(#{$scale} * 20px);
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            text-align: center;
            color: #FFFFFF;
            position: absolute;
            bottom: calc(#{$scale} * 56px);
            left: 50%;
            transform: translate(-50%, 0);
          }

        }
      }
      .active{
        background: transparent;
      }

    }
  }

  .messageBackStyle {
    position: fixed;
    // top: calc(#{$scale} * 40px);
    // right: calc(#{$scale} * 262px);
    right: calc(#{$scale} * 60px);
    top: calc(#{$scale} * 40px);
    width: calc(#{$scale} * 95px);
    height: calc(#{$scale} * 55px);
    z-index: 90;
  }

  .messageBackStyleP {

    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 90;

    .messageInfo {
      position: fixed;
      top: calc(#{$scale} * 40px);
      right: calc(#{$scale} * 262px);
    }

  }

  </style>
